// extracted by mini-css-extract-plugin
module.exports = {"title":"__3wELB","open":"NWE_5","collapse":"b1ZsD"};